const { default: styled } = require('styled-components');
import {
  HeadlineOne,
  HeadlineTwo,
} from 'components/atoms/SectionWrapper.style';

export const WrapperCounterStyle = styled.div`
  text-align: center;
  text-transform: uppercase;

  @media ${({ theme }) => theme.media.mobile} {
    margin: 5px;
    width: 100%;
  }
  @media ${({ theme }) => theme.media.tablet} {
    margin: 5px;
    width: 250px;
  }
`;

export const Border = styled.div`
  max-width: 250px;
  padding: 1rem;
  position: relative;
  background: linear-gradient(to right, green, black);
  padding: 3px;
  border-radius: 50%;
  div {
    background: #fff;
    padding: 2rem;
    border-radius: 50%;
  }
`;

export const HeadlineECounterdit = styled(HeadlineTwo)`
  margin-top: 30px;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  @media ${({ theme }) => theme.media.tablet} {
    /* text-align: justify; */
    font-size: 20px;
    /* display: flex; */
  }
`;
